import { cloudAuthDesktopV2 } from "./cloudAuthDesktopV2";
import { getWebApiBaseUrl } from "../lib/runtime";
import type { StoryCraftAreaId } from "../../shared/craftAreas";

export type WritingResourceSearchHit = {
  resourceTitle: string;
  itemTitle: string;
  url: string;
  excerpt: string;
  craftAreas: string[];
  similarity: number;
};

export async function searchWritingResourcesForChat(args: {
  query: string;
  craftAreas?: StoryCraftAreaId[];
  limit?: number;
}): Promise<WritingResourceSearchHit[]> {
  if (!cloudAuthDesktopV2.isSignedIn()) return [];
  const token = await cloudAuthDesktopV2.getValidAccessToken().catch(() => null);
  if (!token) return [];

  const base = getWebApiBaseUrl();
  const res = await fetch(`${base}/api/writing-resources/search`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: args.query,
      craftAreas: args.craftAreas,
      limit: args.limit ?? 5,
    }),
  });
  if (!res.ok) return [];
  const data = (await res.json()) as { hits?: WritingResourceSearchHit[] };
  return Array.isArray(data.hits) ? data.hits : [];
}
